/** How long a line stays before the next one may replace it, so a fast run never flickers past. */
export const LIVE_TEXT_DWELL_MS = 900

export type LiveTextPart = { kind: 'words'; text: string } | { kind: 'number'; text: string }

export function splitNumbers(text: string): LiveTextPart[] {
  return text
    .split(/(\d+)/)
    .filter((run) => run !== '')
    .map((run) =>
      /^\d+$/.test(run) ? { kind: 'number', text: run } : { kind: 'words', text: run },
    )
}

/** Whether two lines differ only in their numbers, as "2 of 4 pages read" and "3 of 4 pages read" do. */
export function differsOnlyInNumbers(a: string, b: string): boolean {
  const left = splitNumbers(a)
  const right = splitNumbers(b)
  return (
    left.length === right.length &&
    left.every(
      (part, index) =>
        part.kind === right[index]!.kind &&
        (part.kind === 'number' || part.text === right[index]!.text),
    )
  )
}
